import React from 'react'
import "./FormCard.scss"

let STATE_ABBR = process.env.STATE_ABBR;
STATE_ABBR = STATE_ABBR.toUpperCase()
let SEAL_FILENAME = process.env.SEAL_FILENAME;
const stateSeal = require("../../common/img/seals/" +
  STATE_ABBR + (SEAL_FILENAME ? `/${SEAL_FILENAME}` : "/seal.svg"))
const isIE11 = !!window.MSInputMethodContext && !!document.documentMode;

export default ({title, seal, leftColumn, rightColumn, children}) => {
  const columnStyles = isIE11 ? {flex: '0 0 250px'} : undefined
  return (
    <div className="fc-login-wrapper wizard">
      <div className="fc-header">
        {
          seal &&
          <img src={stateSeal} alt="State seal" />
        }
        <h2>{title}</h2>
      </div>
      <div className="fc-body">
        {
          children ?
          children
          :
          <React.Fragment>
            <div className="fc-column secondary" style={columnStyles}>
              {leftColumn}
            </div>
            <div className="fc-column" style={columnStyles}>
              {rightColumn}
            </div>
          </React.Fragment>
        }
      </div>
    </div>
)}



// WEBPACK FOOTER //
// ./src/components/FormCard/FormCard.js